export const importGoogleApis = (): Promise<HTMLScriptElement> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "https://accounts.google.com/gsi/client"
    script.addEventListener("load", () => resolve(script), false)
    script.addEventListener("error", () => reject(script), false)

    document.body.appendChild(script)
  })
}
